<template>
  <div class="datepicker-container">
    <div class="datepicker-container__wrap">
      <a-range-picker
        v-if="type > 1 && type <= 30"
        ref="datepicker"
        :format="format"
        :disabled-date="disabledDate"
        :value="value"
        :class="{'isError': isError}"
        show-time
        :mode="mode2"
        :placeholder="['Start Date', 'End Date']"
        :disabled="disabled"
        @change="handleDateChange"
      >
        <template slot="dateRender" slot-scope="current, today">
          <div class="ant-calendar-date" :style="getCurrentStyle(current, today)">
            {{ current.date() }}
          </div>
        </template>
        <a-icon type="calendar" slot="suffixIcon" />
      </a-range-picker>
      <a-date-picker
        v-if="type === 1"
        ref="datepicker"
        :format="format"
        :disabled-date="disabledDate"
        :value="value"
        placeholder="Select Date"
        :disabled="disabled"
        :class="{'is-error': isError}"
        @change="handleDateChange"
      />
      <a-range-picker
        v-if="type > 30"
        :placeholder="['Start Month', 'End Month']"
        format="YYYY-MM"
        :value="value"
        :mode="mode2"
        :disabled="disabled"
        @panelChange="handlePanelChange"
        @change="handleDateChange"
      />
    </div>
    <div class="datepicker-container__error-message" v-if="isError">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';

export default {
    name: 'AntDatepicker',
    props: {
        format: {
            default: 'DD-MMM-YYYY',
        },
        type: {
            type: Number,
            default: 1,
        },
        value: {
            default: null,
        },
        isError: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            default: '',
        },
        disabled: {
            default: false,
        },
    },
    data() {
        return {
            mon: [],
        };
    },
    computed: {
        mode2() {
            if (this.type > 30) {
                return ['month', 'month'];
            }
            return ['date', 'date'];
        },
    },
    methods: {
        handlePanelChange(value) {
            this.$emit('change', value);
        },
        disabledDate(current) {
            // Can not select days before today
            return current < moment().subtract(1, 'days');
        },
        handleDateChange(date) {
            this.$emit('change', date);
        },
        getCurrentStyle(current) {
            const style = {};
            if (this.value) {
                const diff = current.diff(this.value[0], 'days');
                if (diff % this.type === 0 && current.isSameOrAfter(this.value[0]) && current.isSameOrBefore(this.value[1])) {
                    style.border = '1px solid #1890ff';
                    style.borderRadius = '50%';
                }
            }
            return style;
        },
    },
};
</script>

<style lang="scss" >
.datepicker-container {
  position: relative;
  width: 100%;
  .is-error {
    border-color: $red !important;
    &:focus {
        box-shadow: 0 0 0 3px rgba($red, 0.25) !important;
    }
  }
  &__error-message {
    font-size: 0.8rem;
    font-weight: 300;
    color: $red;
    padding-top: 0.25rem;
  }
  .ant-calendar-picker {
    width: 100%;
    &.is-error {
      .ant-calendar-picker-input {
        border-color: $red !important;
        &:focus {
            box-shadow: 0 0 0 3px rgba($red, 0.20) !important;
        }
      }
    }
  }
}
.ant-calendar-time-picker-btn{
  display: none !important;
}
.has-error {
  .ant-calendar-picker {
    &:focus {
      .ant-calendar-picker-input {
        box-shadow: 0 0 0 2px rgba($red, 0.20) !important;
      }
    }
    .ant-calendar-picker-input {
      border-color: $red !important;
    }
  }
  .ant-time-picker-input, .ant-input-number {
    border-color: $red !important;
  }
  .ant-form-explain, .ant-form-split {
    color: $red !important;
  }
}
</style>
